export default {"src":"/_next/static/media/NCLH.0658eaab.svg","height":18,"width":18};